
import { mapGetters } from 'vuex'
import { header } from '../../customWhiteLabel'
export default {
  data() {
    return {
      header,
    }
  },
  computed: {
    ...mapGetters('cart', ['totalCartPrice']),
  },
}
